import { ReactNode, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, MenuIcon } from './Icons';

interface LayoutProps {
  children: ReactNode;
}

const menuItems = [
  { href: '/', label: 'Monitor de OS', icon: '🖥️' },
  { href: '/os/nova', label: 'Gerar OS', icon: '📝' },
  { href: '/clientes', label: 'Base de Clientes', icon: '👥' },
  { href: '/caixa', label: 'Caixa', icon: '💸' },
  { href: '/dashboard', label: 'Dashboard', icon: '📊' },
  { href: '/pix', label: 'Enviar PIX', icon: '⚡' },
];

export default function Layout({ children }: LayoutProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="min-h-screen">
      {/* Home Button */}
      <Link
        to="/"
        className="fixed top-4 left-4 z-30 p-2 rounded-full bg-white/70 backdrop-blur-sm hover:bg-white transition shadow-md"
        title="Página Inicial"
      >
        <HomeIcon className="h-6 w-6 text-amber-600" />
      </Link>

      {/* Menu Dropdown */}
      <div className="fixed top-4 right-4 z-30">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="p-2 rounded-full bg-white/70 backdrop-blur-sm hover:bg-white transition shadow-md"
        >
          <MenuIcon className="h-6 w-6 text-slate-600" />
        </button>

        {menuOpen && (
          <>
            {/* Backdrop */}
            <div
              className="fixed inset-0 z-10"
              onClick={() => setMenuOpen(false)}
            />
            {/* Dropdown */}
            <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-xl ring-1 ring-black ring-opacity-5 z-20">
              <div className="py-1">
                {menuItems.map((item) => (
                  <Link
                    key={item.href}
                    to={item.href}
                    onClick={() => setMenuOpen(false)}
                    className={`block px-4 py-2 text-sm transition ${
                      location.pathname === item.href
                        ? 'bg-amber-50 text-amber-700'
                        : 'text-slate-700 hover:bg-indigo-50 hover:text-indigo-700'
                    }`}
                  >
                    {item.icon} {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </>
        )}
      </div>

      {/* Main Content */}
      <main className="pt-16 pb-8 px-4">{children}</main>
    </div>
  );
}



